// Utilities for enabling maintenance mode via environment flag
export const isMaintenanceMode = () => {
  const raw = process.env.REACT_APP_MAINTENANCE_MODE;
  const val = String(raw ?? "false")
    .trim()
    .toLowerCase();
  return val === "true" || val === "1" || val === "yes" || val === "on";
};

export const MAINTENANCE_BANNER_TEXT =
  "This site is under maintenance. Some functions may be temporarily unavailable.";

export const MAINTENANCE_ACTION_BLOCK_TEXT =
  "Maintenance mode: Submissions and logins are temporarily disabled. Please try again later.";
